import PropTypes from 'prop-types';

import giftbox from 'images/giftbox.svg';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/melody/shippingOption/shippingDowngrade.scss';

const ShippingDowngrade = ({ downgradeEstimateDollars, isLoading, onSwitchToNonRushClicked }, { testId }) => (
  <div className={css.wrapper} data-test-id={testId('shippingDowngrade')}>
    <img src={giftbox} alt="giftbox" />
    <div>
      <p>
        Get {toUSD(downgradeEstimateDollars)} in Zappos Rewards Points.
      </p>
      <a href="/checkout" onClick={onSwitchToNonRushClicked}>
        { isLoading ? 'Updating...' : 'Switch to 3-5 Day Shipping' }
      </a>
    </div>
  </div>
);

ShippingDowngrade.contextTypes = {
  testId: PropTypes.func
};

export default ShippingDowngrade;
